import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"
import type { PricingResponse } from "../../../../graphql/types"
import {
    DELETE_PRICING_CLICKED,
    FETCH_SPECIAL_PRICINGS_SUCCESS,
    PRICING_LOCATION_SAVE_SUCCESS,
    PRICING_SAVE_SUCCESS,
} from "./actions"
import { ACCOUNT_SELECTED, REFETCH_DATA } from "../../../auth/actions"

export type PricingsState = {
    data: Maybe<PricingResponse>
}

export const createDefaultPricingsState = () => ({
    data: null,
})
export const pricingsReducer = (
    state: Maybe<PricingsState> = undefined,
    action: Record<string, any>
): PricingsState => {
    if (!state) {
        return createDefaultPricingsState()
    }

    switch (action.type) {
        case ACCOUNT_SELECTED:
        case REFETCH_DATA:
            return createDefaultPricingsState()

        case FETCH_SPECIAL_PRICINGS_SUCCESS:
            return { ...state, data: action.payload.pricingResponse }

        case PRICING_SAVE_SUCCESS: {
            const pricingState = state.data

            if (!pricingState || !pricingState.data) {
                return { ...state }
            }

            // Update
            if (pricingState.data.find(og => og.id === action.payload.data.id)) {
                return {
                    ...state,
                    data: {
                        ...pricingState,
                        data: pricingState.data.map(c => (c.id !== action.payload.data.id ? c : action.payload.data)),
                    },
                }
            } else {
                return { ...state, data: { ...pricingState, data: [...pricingState.data, action.payload.data] } }
            }
        }

        case PRICING_LOCATION_SAVE_SUCCESS: {
            const pricingState = state.data

            if (!pricingState || !pricingState.overrides) {
                return { ...state }
            }

            // If Override was canceled, delete override from store
            const saveRequestData = action.payload.saveRequestData

            if (
                !action.payload.data &&
                pricingState.overrides.find(
                    og => og.locationId === action.payload.locationId && og.data.id === saveRequestData.id
                )
            ) {
                return {
                    ...state,
                    data: {
                        ...pricingState,
                        overrides: pricingState.overrides.filter(c => c.data.id !== saveRequestData.id),
                    },
                }
            }

            // Should not happen
            if (
                !action.payload.data &&
                !pricingState.overrides.find(
                    og => og.locationId === action.payload.locationId && og.data.id === saveRequestData.id
                )
            ) {
                return { ...state }
            }

            const findOverride = pricingState.overrides.find(
                og => og.locationId === action.payload.locationId && og.data.id === action.payload.data.data.id
            )

            // Update
            if (findOverride) {
                return {
                    ...state,
                    data: {
                        ...pricingState,
                        overrides: pricingState.overrides.map(c =>
                            c.locationId === action.payload.locationId && c.data.id === action.payload.data.data.id
                                ? action.payload.data
                                : c
                        ),
                    },
                }
            } // Create
            else {
                return {
                    ...state,
                    data: { ...pricingState, overrides: [...pricingState.overrides, action.payload.data] },
                }
            }
        }

        case DELETE_PRICING_CLICKED: {
            const pricingState = state.data

            if (!pricingState || !pricingState.data) {
                return { ...state }
            }

            return {
                ...state,
                data: { ...pricingState, data: pricingState.data.filter(og => og.id !== action.payload.pricingId) },
            }
        }

        default:
            return state
    }
}
